import Dimens from "../../../../theme/dimens";
import { useTheme } from "@mui/material";

/**
 * useStyles custom hook generates MUI theme dependent styles for the FeaturesTab component.
 * 
 * @returns An object containing the styled classes.
 */
const useStyles = () => {

  const theme = useTheme();

  const styles = {
    innerWrapper: {
      flex: 1,
      overflowY: 'auto',
      p: 0
    },
    contentWrapper: {
      overflowY: 'auto',
      p: 0
    },
    content: {
      m: 0,  
      p: Dimens.spacing.sm,
      [ theme.breakpoints.down('sm') ]: {
        p: Dimens.spacing.xxs
      }
    }
  };

  return styles;
};

export default useStyles;